import IAction from "models/IAction";
import BaseReducer from "utilities/BaseReducer";
import CercaAction from "./CercaAction";
import CercaSimulazioneFormModel from "./models/CercaSimulazioneFormModel";
import ICercaState from "./models/ICercaState";
import CercaPreventiviTabellaModel from "./models/CercaPreventiviTabellaModel";
import CercaPreventiviModel from "./models/CercaPreventiviModel";
import CercaSimulazioneModel from "./models/CercaSimulazioneModel";
import CercaDettalgioSimulazioneModel from "./models/CercaDettalgioSimulazioneModel";
import CercaPreventiviFormModel from "./models/CercaPreventiviFormModel";
import CercaDettalgioPreventivoModel from "./models/CercaDettalgioPreventivoModel";

export default class CercaReducer extends BaseReducer<ICercaState> {
    public readonly initialState: ICercaState = {
        cercaSimulazioneForm: new CercaSimulazioneFormModel({
            colName: "id",
            direction: "D",
        }),
        cercaPreventiviForm: new CercaPreventiviFormModel({
            colName: "idEstimate",
            direction: "D",
        }),
        cercaSimulazioneResponse: new CercaSimulazioneModel({}),
        cercaPreventiviResponse: new CercaPreventiviModel({}),
        Functions: [],
    };

    public [CercaAction.REQUEST_CERCA_SIMULAZIONE_FORM_FINISHED](
        state: ICercaState,
        action: IAction<CercaSimulazioneFormModel>
    ): ICercaState {
        return {
            ...state,
            cercaSimulazioneForm: action.payload!,
        };
    }

    public [CercaAction.REQUEST_CERCA_PREVENTIVI_FORM_FINISHED](
        state: ICercaState,
        action: IAction<CercaPreventiviFormModel>
    ): ICercaState {
        return {
            ...state,
            cercaPreventiviForm: action.payload!,
        };
    }

    public [CercaAction.REQUEST_CERCA_SIMULAZIONE_RESET](
        state: ICercaState,
        action: IAction<CercaSimulazioneFormModel>
    ): ICercaState {
        return {
            ...this.initialState,
        };
    }

    public [CercaAction.REQUEST_CERCA_SIMULATION_FINISHED](
        state: ICercaState,
        action: IAction<CercaSimulazioneModel>
    ): ICercaState {
        return {
            ...state,
            cercaSimulazioneResponse: action.payload!,
        };
    }

    public [CercaAction.REQUEST_FIND_SIMULATION_FINISHED](
        state: ICercaState,
        action: IAction<CercaDettalgioSimulazioneModel>
    ): ICercaState {
        return {
            ...state,
            cercaDettalgioSimulazioneModel: action.payload!,
            //dettalgioPreventivoModel: this.initialState.dettalgioPreventivoModel,// si resetta l' eventuale preventivo cercato
        };
    }

    public [CercaAction.REQUEST_FIND_SIMULATION_BY_ID_FINISHED](
        state: ICercaState,
        action: IAction<CercaSimulazioneModel>
    ): ICercaState {
        return {
            ...state,
            cercaSimulazioneResponse: new CercaSimulazioneModel({
                data: [action.payload!],
                pageNumber: 1,
                pageSize: 1,
                totalPages: 1,
                totalRecords: 1,
            }),
        };
    }

    public [CercaAction.REQUEST_CERCA_PREVENTIVI_FINISHED](
        state: ICercaState,
        action: IAction<CercaPreventiviModel>
    ): ICercaState {
        return {
            ...state,
            cercaPreventiviResponse: action.payload!,
        };
    }

    public [CercaAction.REQUEST_CERCA_PREVENTIVI_RESET](
        state: ICercaState,
        action: IAction<CercaPreventiviFormModel>
    ): ICercaState {
        return {
            ...this.initialState,
            dettalgioPreventivoModel: state.dettalgioPreventivoModel,
        };
    }

    public [CercaAction.REQUEST_DETTAGLIO_PREVENTIVO_BY_ID_FINISHED](
        state: ICercaState,
        action: IAction<CercaPreventiviTabellaModel>
    ): ICercaState {
        return {
            ...state,
            cercaDettalgioPreventivoModel: action.payload!,
        };
    }

    public [CercaAction.REQUEST_FIND_PREVENTIVO_BY_ID_FINISHED](
        state: ICercaState,
        action: IAction<CercaDettalgioPreventivoModel>
    ): ICercaState {
        return {
            ...state,
            dettalgioPreventivoModel: action.payload!,
        };
    }

    public [CercaAction.REQUEST_FIND_PREVENTIVO_BY_ID_RESET](
        state: ICercaState,
        action: IAction<CercaDettalgioPreventivoModel>
    ): ICercaState {
        return {
            ...state,
            dettalgioPreventivoModel: this.initialState.dettalgioPreventivoModel,
        };
    }
    public [CercaAction.REQUEST_FUNCTION_GET_FINISHED](state: ICercaState, action: IAction<string[]>): ICercaState {
        sessionStorage.setItem("Functions", JSON.stringify(action.payload));
        return {
            ...state,
            Functions: action.payload!,
        };
    }
}
